import { useRef, useCallback, useState } from "react";
import ArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import CONSTANTS from "core/constants";
import { useOnClickOutside } from "hooks";
import { Typography } from "components/typography";
import {
  TitleContainer,
  ArrowContainer,
  InnerContainer,
  Container,
} from "./monthPicker.styles";
import MonthCalendar from "../monthCalendar";

const MonthPicker = ({ date = new Date() }: { date?: Date }) => {
  const [isMonthPickerVisible, setMonthPickerVisible] = useState(false);

  const { t } = useTranslation();
  const ref = useRef(null);

  const getMonthTimeStamp = useCallback(() => {
    return format(date, CONSTANTS.DATE_FORMAT.MONTH_NAME_DATE_FORMAT);
  }, [date]);

  const getYearTimeStamp = useCallback(() => {
    return format(date, CONSTANTS.DATE_FORMAT.YEAR_DATE_FORMAT);
  }, [date]);

  useOnClickOutside(ref, true, () => {
    setMonthPickerVisible(false);
  });

  return (
    <Container ref={ref}>
      <InnerContainer
        data-testid="month-picker-opener"
        onClick={() => setMonthPickerVisible(!isMonthPickerVisible)}
      >
        <TitleContainer data-testid="month-title-container">
          <Typography insensitive variant="h2">
            {t(getMonthTimeStamp())} {getYearTimeStamp()}
          </Typography>
        </TitleContainer>
        <ArrowContainer>
          <ArrowDown />
        </ArrowContainer>
      </InnerContainer>
      <MonthCalendar
        isOpen={isMonthPickerVisible}
        onSelect={() => setMonthPickerVisible(!isMonthPickerVisible)}
      />
    </Container>
  );
};

export default MonthPicker;
